import { inject } from '@angular/core';
import { Router, Routes, UrlTree } from '@angular/router';
import { AUTH_PATH, DENTAL, DENTAL_PROCEDURE, FIND_A_DENTIST, PHARMACY_LIST, PROFESSIONALS, PROFILE, REQUEST_IMAGING_APPOINTMENT, REQUEST_SURGICAL_APPOINTMENT, RESOURCES, VERIFY_PROFILE, PROFESSIONAL_BOOKED_APPOINTMENT, VIRTUAL_URGENT_CARE, MENTAL_HEALTH_COUNSELING, VISION_SERVICE, OFFICE_VISIT, SURGICAL, IMAGING, HEALTHSHARE_SERVICE, LAB_TEST, PHARMACY, PAYMENT, PROFILE_COMPLETION, ADD_PROFILE_CARD, PLUS_MEMBERSHIP, BUY_MEMBERSHIP, APPOINTMENT_BOOKED_DETAIL, ACA_CONTENT, CHANGE_PLAN, RESET_PASSWORD_PATH, FORGOT_PASSWORD_PATH, CREAT_PASSWORD_PATH, BRANDED_MEDICINES_REQUEST, PHARMACY_BRAND_DETAILS, ACAWELLNESS, PHARMACY_LIST_WP, WOW_SSO,OUR_POLICY } from '@src/app/core/constants';
import { preventAuthGuard, AuthorizationGuard } from '@src/app/core/guards';
import { PurchaseRedirectGuard } from '@src/app/core/guards/purchase-redirect.guard';
import { verifyprofileguardGuard } from '@src/app/core/guards/verifyprofileguard.guard'; 
import { MiniEnvConfigResolver } from '@src/app/core/resolvers/mini-env-config.resolver';
import { MiniEnvResolver } from '@src/app/core/resolvers/mini-env.resolver';
import { SeoResolver } from '@src/app/core/resolvers/seo.resolver';
import { TranslationDataService } from '@src/app/core/services/translation-data.service';
import { ErrorPageComponent } from '@src/app/pages/error-page/error-page.component';
import { BaseComponent } from '@src/app/pages/layout/website/base/base.component';
import { ACAWellnessComponent } from '@src/app/pages/mini-env/aca-wellness/aca-wellness.component';
import { PdfLayoutComponent } from '@src/app/pages/pdf-layout/pdf-layout.component';

export const routes: Routes = [
  { path: '', redirectTo: PROFILE, pathMatch: 'full' },
  {
    canActivate: [preventAuthGuard],
    path: AUTH_PATH,
    loadChildren: () => import('@views/auth/auth.module').then(m => m.AuthModule),
    resolve: { MiniEnvConfigResolver },
  },
  {
    path: PROFILE,
    canActivate: [AuthorizationGuard],
    loadChildren: () => import('@src/app/pages/layout/member-portal/memberportal.module').then(x => x.MemberPortalModule),
    resolve: { MiniEnvConfigResolver },
  },
  {

    path: WOW_SSO,
    loadComponent: () =>
      import('@views/profile/sso-page/sso-page.component').then(
        m => m.SsoCallbackComponent,
      ),

    // resolve: { TranslationDataService }
  },
  {
      path: OUR_POLICY,
      loadComponent: () =>
      import('@views/our-policy/our-policy.component').then(x => x.OurPolicyComponent),
      title: 'Our Policy - UnifyWell Benefits',
      data: {
       languageFilePath: "assets/i18n/our-policy/"
      },
      resolve: { TranslationDataService, }
 },
  {
      path: OUR_POLICY,
      loadComponent: () =>
      import('@views/our-policy/our-policy.component').then(x => x.OurPolicyComponent),
      title: 'Our Policy - WoW Health',
      data: {
       languageFilePath: "assets/i18n/our-policy/"
      },
      resolve: { TranslationDataService, }
 },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthorizationGuard],
    resolve: { MiniEnvConfigResolver },
    children: [
      {
        path: CHANGE_PLAN,
        loadComponent: () =>
          import('@views/change-plan/change-plan.component').then(x => x.ChangePlanComponent),
        data: {
          languageFilePath: "assets/i18n/everydaycare/"
        },
        title: 'Change Plan - Unifywell Health',
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: 'reset-password',
        redirectTo: (snapshot): string | UrlTree => {
          const router = inject(Router);
          return router.createUrlTree([`/${RESET_PASSWORD_PATH}`], {
            queryParams: snapshot.queryParams,
          });
        },
        pathMatch: 'full'
      },
      {
        path: 'forgot-password',
        redirectTo: `/${FORGOT_PASSWORD_PATH}`,
        pathMatch: 'full'
      },
      {
        path: 'access-account',
        redirectTo: `/${CREAT_PASSWORD_PATH}`,
        pathMatch: 'full'
      },
      {

        canActivate: [AuthorizationGuard],
        path: ACA_CONTENT,
        loadComponent: () =>
          import('@views/wellness-stats-listing/wellness-stats-listing.component').then(x => x.WellnessStatsListingComponent),
        data: {
          languageFilePath: "assets/i18n/aca-stats-listing/"
        },
        title: 'ACA Content - Unifywell Health',
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: RESOURCES,
        loadComponent: () =>
          import('@views/resources/resources.component').then(x => x.ResourcesComponent),
        data: {
          languageFilePath: "assets/i18n/resources/"
        },
        resolve: { TranslationDataService }
      },
      {
        path: PHARMACY_LIST,
        loadComponent: () =>
          import('@views/pharmacies-list/pharmacies-list.component').then(
            x => x.PharmaciesListComponent,
          ),
        data: {
          languageFilePath: "assets/i18n/pharmacy/"
        },
        resolve: { TranslationDataService }
      },
         {
        path: BRANDED_MEDICINES_REQUEST,
        loadComponent: () =>
          import('@views/branded-medicine-request/branded-medicine-request.component').then(
            x => x.BrandedMedicineRequestPage,
          ),
        title: 'Branded Medicine Request - WoW Health',
        data: {
          languageFilePath: "assets/i18n/pharmacy/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: PHARMACY_BRAND_DETAILS,
        loadComponent: () =>
          import('@views/pharmacy-brand-detail/pharmacy-brand-detail.component').then(
            x => x.PharmacyBrandDetailComponent,
          ),
        title: 'Pharmacy Brand Details - WoW Health',
        data: {
          languageFilePath: "assets/i18n/pharmacy/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: FIND_A_DENTIST,
        loadComponent: () =>
          import('@views/find-a-dentist/find-a-dentist.component').then(x => x.FindADentistComponent),
        data: {
          languageFilePath: "assets/i18n/find-a-dentist/"
        },
        resolve: { TranslationDataService }
        // canActivate: [AuthorizationGuard]
      },
      {
        path: REQUEST_SURGICAL_APPOINTMENT,
        loadComponent: () =>
          import('@views/request-surgical-appointment/request-surgical-appointment.component').then(
            x => x.RequestSurgicalAppointmentComponent,
          ),
        data: {
          languageFilePath: "assets/i18n/surgical/"
        },
        resolve: { TranslationDataService }
      },
      {
        path: REQUEST_IMAGING_APPOINTMENT,
        loadComponent: () =>
          import('@views/request-imaging-appointment/request-imaging-appointment.component').then(
            x => x.RequestImagingAppointmentComponent,
          ),
        data: {
          languageFilePath: "assets/i18n/imaging/"
        },
        resolve: { TranslationDataService }
      },
      // {
      //   path: VIRTUAL_URGENT_CARE,
      //   loadComponent: () =>
      //     import('@views/virtual-urgent-care/virtual-urgent-care.component').then(
      //       x => x.VirtualUrgentCareComponent,
      //     ),
      //   data: {
      //     languageFilePath: "assets/i18n/virtual-urgent-care/"
      //   },
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: DENTAL,
      //   loadComponent: () =>
      //     import('@views/dental/dental.component').then(x => x.DentalComponent),
      //   title: 'Simple Solutions for all Your Dental Problems - Unifywell Health',
      //   data: {
      //     languageFilePath: "assets/i18n/dental/"
      //   },
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: VISION_SERVICE,
      //   loadComponent: () =>
      //     import('@views/vision-care/vision-care.component').then(
      //       m => m.VisionCareComponent,
      //     ),
      //   data: {
      //     languageFilePath: "assets/i18n/vision-care/"
      //   },
      //   title: 'Best Vision Care Services - Clearer Vision Awaits - Unifywell Health',
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: MENTAL_HEALTH_COUNSELING,
      //   loadComponent: () =>
      //     import('@views/mental-health-counselling/mental-health-counselling.component'
      //     ).then(x => x.MentalHealthCounsellingComponent),
      //   title: 'Mental Health Counseling: Improve Your Well-Being - Unifywell Health',
      //   data: {
      //     languageFilePath: "assets/i18n/mental-health-counselling/"
      //   },
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: OFFICE_VISIT,
      //   loadComponent: () =>
      //     import('@views/office-visit/office-visit.component').then(
      //       x => x.OfficeVisitComponent,
      //     ),
      //   title: 'In-Person Visit To Doctor\'s Office - Find Doctor Near You',
      //   data: { metaTitle: 'OfficeVisit', metaDescription: 'Office Visit', languageFilePath: "assets/i18n/office-visit/" },
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: SURGICAL,
      //   loadComponent: () =>
      //     import('@views/surgical/surgical.component').then(
      //       x => x.SurgicalComponent,
      //     ),
      //   title: 'Book Appointments for Surgery/Surgical Treatments - Unifywell Health',
      //   data: {
      //     languageFilePath: "assets/i18n/surgical/"
      //   },
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: IMAGING,
      //   loadComponent: () =>
      //     import('@views/imaging/imaging.component').then(
      //       x => x.ImagingComponent,
      //     ),
      //   title: 'Discounts on Imaging Tests like CT Scans, MRI, Ultrasound - Unifywell Health',
      //   data: {
      //     languageFilePath: "assets/i18n/imaging/"
      //   },
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: HEALTHSHARE_SERVICE,
      //   loadComponent: () =>
      //     import(
      //       '@views/healthshare-services/healthshare-services.component'
      //     ).then(x => x.HealthshareServicesComponent),
      //   title: 'HealthSharing Reimbursement - Unifywell Health',
      //   data: {
      //     languageFilePath: "assets/i18n/healthshare-service/"
      //   },
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: LAB_TEST,
      //   loadComponent: () =>
      //     import('@views/lab-tests/lab-tests.component').then(
      //       x => x.LabTestsComponent,
      //     ),
      //   title: 'Find Lab Tests Online - Easy & Affordable - Unifywell Health',
      //   data: {
      //     languageFilePath: "assets/i18n/lab-test/"
      //   },
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: PHARMACY,
      //   loadComponent: () =>
      //     import('@views/pharmacy/pharmacy.component').then(
      //       x => x.PharmacyComponent,
      //     ),
      //   title: 'Get Discounted Medicines From Your Nearest Pharmacies - Unifywell Health',
      //   data: {
      //     languageFilePath: "assets/i18n/pharmacy/"
      //   },
      //   resolve: { TranslationDataService }
      // },
      {
        path: PROFESSIONALS,
        loadComponent: () =>
          import('@views/find-a-professional/find-a-professional.component').then(x => x.FindAProfessionalComponent),
        // canActivate: [AuthorizationGuard]
      },

      {
        path: 'buy-wow-plus-membership',
        loadComponent: () =>
          import('@views/buy-membership/buy-membership.component').then(x => x.BuyMembershipComponent),
        data: {
          languageFilePath: "assets/i18n/everydaycare/"
        },
        resolve: { TranslationDataService }
      },
      // {
      //   path: 'wow-plus-membership',
      //   canActivate: [PurchaseRedirectGuard],
      //   loadComponent: () =>
      //     import('@views/everydaycare/everydaycare.component').then(x => x.EverydayCareComponent),
      //   data: {
      //     languageFilePath: "assets/i18n/everydaycare/"
      //   },
      //   resolve: { TranslationDataService }
      // },
      {
        path: PROFILE_COMPLETION + "/:id",
        canActivate: [AuthorizationGuard],
        loadComponent: () =>
          import('@views/profile-completion/profile-completion.component').then(x => x.ProfileCompletionComponent)
      },
      {
        path: PROFILE_COMPLETION,
        canActivate: [AuthorizationGuard],
        title: 'Update Information - WoW Health',
        loadComponent: () =>
          import('@views/profile-completion/profile-completion.component').then(x => x.ProfileCompletionComponent)
      },
      {
        path: 'manage-payment-methods',
        loadComponent: () =>
          import('@views/profile/membership/manage-payment-methods/manage-payment-methods.component').then(x => x.ManagePaymentMethodsComponent),
        data: {
          languageFilePath: "assets/i18n/"
        },
        resolve: { TranslationDataService }
        //   data: {
        //   languageFilePath: "assets/i18n"
        // },
      },
      {
        path: 'professionals-detail',
        loadComponent: () =>
          import('@views/professionals-detail/professionals-detail.component').then(x => x.ProfessionalsDetailComponent),
        data: {
          languageFilePath: "assets/i18n/professionals-detail-checkout/"
        },
        resolve: { TranslationDataService }
      },
      {
        path: ADD_PROFILE_CARD,
        loadComponent: () =>
          import('@views/payment/views/add-card-screen/add-card-screen.component').then(x => x.AddCardScreenComponent),
      },
      {
        path: PAYMENT,
        canActivate: [],
        loadComponent: () =>
          import('@views/payment/payment.component').then(x => x.PaymentComponent),
        data: {
          languageFilePath: "assets/i18n/payment/"
        },
        resolve: { TranslationDataService }
      },
      // {
      //   path: BUY_MEMBERSHIP,
      //   canActivate: [PurchaseRedirectGuard],

      //   loadComponent: () =>
      //     import('@views/buy-membership/buy-membership.component').then(x => x.BuyMembershipComponent),
      //   data: {
      //     languageFilePath: "assets/i18n/everydaycare/"
      //   },
      //   title: 'Buy WoW Plus Membership - Unifywell Health',
      //   resolve: { TranslationDataService }
      // },
      // {
      //   path: PLUS_MEMBERSHIP,
      //   canActivate: [PurchaseRedirectGuard],
      //   loadComponent: () =>
      //     import('@views/everydaycare/everydaycare.component').then(
      //       m => m.EverydayCareComponent,
      //     ),
      //   title: 'WoW Plus Membership - Cheaper Healthcare Plans - Unifywell Health',
      //   data: { metaTitle: 'PlusMembership', metaDescription: 'Plus Membership', languageFilePath: "assets/i18n/everydaycare/", isSubDomain: false },
      //   resolve: { TranslationDataService }
      // },
      {
        path: APPOINTMENT_BOOKED_DETAIL,
        loadComponent: () =>
          import('@views/membership-card-contact-detail/membership-card-contact-detail.component').then(x => x.MembershipCardContactDetailComponent),
        title: 'Appointment Detail - Unifywell Health',
        data: {
          languageFilePath: "assets/i18n/appointment-checkout/"
        },
        resolve: { TranslationDataService }
      },
      {
        path: PROFESSIONAL_BOOKED_APPOINTMENT,
        loadComponent: () =>
          import('@views/appointment-checkout/appointment-checkout.component').then(x => x.AppointmentCheckoutComponent),
        data: {
          languageFilePath: "assets/i18n/appointment-checkout/"
        },
        resolve: { TranslationDataService }
      },
      {
        path: ACAWELLNESS,
        data: { metaTitle: 'ACAWELLNESS', metaDescription: 'ACAWELLNESS Description', languageFilePath: "assets/i18n/mini-env/acawellness/" },
        title: 'ACA Wellness - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: ACAWellnessComponent
          }
        ]
      },
    ]
  },
  {
    path: PHARMACY_LIST_WP,
    component: BaseComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('@views/pharmacies-list/pharmacies-list.component').then(x => x.PharmaciesListComponent),
        data: { languageFilePath: "assets/i18n/pharmacy/" },
        resolve: { TranslationDataService }
      },
    ]
  },
  {
    path: VERIFY_PROFILE,
    loadComponent: () =>
      import('@views/verify-profile/verify-profile.component').then(x => x.VerifyProfileComponent),
    data: {
      languageFilePath: "assets/i18n/verify-profile/"
    },
    resolve: { TranslationDataService },
    canActivate: [verifyprofileguardGuard]
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    title : "Error",
    data: {
      type: 404,
      title: 'Oops! This page is missing',
      desc: "Looks like you’ve taken a wrong turn. The page you’re looking for doesn’t exist.",
    },
  },
  {
      path: 'pdf',
      component: PdfLayoutComponent,
      children: [
        {
          path: "pharmacy-card-pdf",
          loadComponent: () =>
            import('@views/pdf-pages/pharmacy-card-pdf/pharmacy-card-pdf.component').then(
              m => m.PharmacyCardPdfComponent,
            ),
        },
      ]
    },
  {
    path: 'error/:type',
    component: ErrorPageComponent,
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
]